import React from 'react';
import SitesCardSkeletonLoader from './SitesCardSkeletonLoader';

export default {
  title: 'Components/LoadingSkeletons/SitesCardSkeletonLoader',
  component: SitesCardSkeletonLoader,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    shouldEnableAnimation: {
      control: { type: 'boolean' },
      description: 'Controls the shouldEnableAnimation prop. By default, it is set to false to keep animations disabled. Set this value to true to enable animations.',
      table: {
        type: { summary: 'Boolean' },
        defaultValue: { summary: false },
      },
    },
    UsageHint: {
      description: 'Usage example: `[...Array(9)].map((_, index) => <SitesCardSkeletonLoader key={index} />)`',
    },
    iconSize: {
      control: { type: 'number' },
      description: 'Specifies the size of the circular icon placeholder.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 36 },
      },
    },
    skeletonMainWidth: {
      control: { type: 'text' },
      description: 'Sets the width of the main skeleton text placeholder.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '90%' },
      },
    },
    skeletonMainHeight: {
      control: { type: 'number' },
      description: 'Sets the height of the main skeleton text placeholder.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 20 },
      },
    },
    skeletonTextWidth1: {
      control: { type: 'text' },
      description: 'Sets the width of the first line of text in the details section.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '50%' },
      },
    },
    skeletonTextWidth2: {
      control: { type: 'text' },
      description: 'Sets the width of the second line of text in the details section.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '90%' },
      },
    },
    skeletonDetailHeight: {
      control: { type: 'number' },
      description: 'Specifies the height of the skeleton placeholders in the details section.',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 16 },
      },
    },
    skeletonDetailWidth1: {
      control: { type: 'text' },
      description: 'Sets the width of the first column in the details section.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '60%' },
      },
    },
    skeletonDetailWidth2: {
      control: { type: 'text' },
      description: 'Sets the width of the second column in the details section.',
      table: {
        type: { summary: 'string | number' },
        defaultValue: { summary: '40%' },
      },
    },
  },
};

// Default Template
const Template = (args) => <SitesCardSkeletonLoader {...args} />;

export const Default = Template.bind({});
Default.args = {
  iconSize: 36,
  skeletonMainWidth: '90%',
  skeletonMainHeight: 20,
  skeletonTextWidth1: '50%',
  skeletonTextWidth2: '90%',
  skeletonDetailHeight: 16,
  skeletonDetailWidth1: '60%',
  skeletonDetailWidth2: '40%',
};

export const SmallSkeletonLoader = Template.bind({});
SmallSkeletonLoader.args = {
  iconSize: 24,
  skeletonMainWidth: '80%',
  skeletonMainHeight: 16,
  skeletonTextWidth1: '40%',
  skeletonTextWidth2: '80%',
  skeletonDetailHeight: 12,
  skeletonDetailWidth1: '50%',
  skeletonDetailWidth2: '30%',
};

export const LargeSkeletonLoader = Template.bind({});
LargeSkeletonLoader.args = {
  iconSize: 48,
  skeletonMainWidth: '100%',
  skeletonMainHeight: 24,
  skeletonTextWidth1: '70%',
  skeletonTextWidth2: '100%',
  skeletonDetailHeight: 20,
  skeletonDetailWidth1: '70%',
  skeletonDetailWidth2: '50%',
};
